export default {
  setLocale (state, payload) {
    state.locale = payload
  }
}
